export const environment = {
  api_url: 'https://crm.pbgas.sk/api/v1',
  stage: 'production',
  disable_2fa_prompt: true,
};
